import { UseFormRegisterReturn, UseFormSetError } from "react-hook-form";

import { TermsAndConditions } from "~/common/components/signUp";
import SignUpFormLayout from "~/common/components/signUp/SignUpFormLayout";
import SignUpProgress from "~/common/components/signUp/SignUpProgress";
import Input from "~/common/components/ui/Input";
import { TermsAndConditionsSchemaType } from "~/common/utils/signUpSchemas";
import { SignUpPatientSchemaType } from "~/patients/utils";
import { FormErrors } from "~/patients/utils/types/forms";

interface NewPatientTermsAndConditionsFormProps {
  handleGoBack: () => void;
  totalSteps: number;
  register: (
    data: keyof TermsAndConditionsSchemaType,
  ) => UseFormRegisterReturn<string>;
  onNext: () => Promise<void>;
  step: number;
  errors?: FormErrors<TermsAndConditionsSchemaType>;
  isAdult: boolean;
  setError: UseFormSetError<SignUpPatientSchemaType>;
  currentGuardianName?: string;
}

export const NewPatientTermsAndConditionsForm = ({
  onNext,
  register,
  handleGoBack,
  totalSteps,
  errors,
  step,
  isAdult,
  setError,
  currentGuardianName,
}: NewPatientTermsAndConditionsFormProps) => {
  const onSubmit = async () => {
    if (!isAdult && !currentGuardianName) {
      setError("termsAndConditions.guardian_name", {
        type: "manual",
        message: "Guardian name is required if you are not an adult",
      });
      return;
    }

    await onNext();
  };

  const infoText = isAdult
    ? "Please review and accept PsychNow's Terms & Conditions and Privacy Policy to continue."
    : "Accounts for users between the ages of 13 and 17 must be authorized by a parent or guardian.";

  return (
    <>
      <SignUpProgress step={step} totalSteps={totalSteps} />
      <SignUpFormLayout
        title="Terms & Conditions"
        handleData={onSubmit}
        submitLabel="Next"
        handleGoBack={handleGoBack}
      >
        <div className="flex flex-col gap-7">
          <p>{infoText}</p>
          <div className="flex size-full flex-grow flex-col justify-between lg:justify-normal lg:gap-12">
            <TermsAndConditions
              register={() => register("termsAndConditions")}
              error={errors?.termsAndConditions?.message}
            />
          </div>
          {!isAdult && (
            <>
              <p>
                Enter your name below as a digital signature authorizing
                creation of this account for your minor or dependent child.
              </p>
              <Input
                id="guardian_name"
                label="Name of parent or guardian"
                {...register("guardian_name")}
                error={errors?.guardian_name?.message}
              />
            </>
          )}
        </div>
      </SignUpFormLayout>
    </>
  );
};
